/* eslint-disable react/destructuring-assignment, react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';

import {
    commonDefaultProps,
    commonPropTypes,
    concatClassNames,
    ypUtilsToClassNames,
    filterProps,
} from '../Abstrap/Abstrap';

const propTypes = {
    ...commonPropTypes,
    isVisible: PropTypes.bool,
    manual: PropTypes.bool,
};

const defaultProps = {
    ...commonDefaultProps,
    isVisible: false,
    manual: false,
};

const TooltipContainer = (props) => {
    const classNames = [
        'c-tooltip-container',
        props.manual ? 'c-tooltip-container--manual' : 'c-tooltip-container--hover',
        props.isVisible ? 'is-visible' : '',
        props.className,
        ...ypUtilsToClassNames(props.ypUtils),
    ];
    return (
        <props.componentClass
            className={concatClassNames(classNames)}
            {...filterProps(propTypes, props)}
        >
            {props.children}
        </props.componentClass>
    );
};

TooltipContainer.propTypes = propTypes;

TooltipContainer.defaultProps = defaultProps;

export default TooltipContainer;
